import React from 'react';
import { ReactSVG } from 'react-svg';
import { Tooltip } from '@material-ui/core';
import TooltipV2 from '@/components/Tooltip';
import { Icons } from '@/assets';

const ShiftStatus = ({
  shiftData,
  shiftType,
  terminalId,
  terminalSlug,
  restrictionName,
  containerType,
  cls,
  idx,
  restrictionKey,
  selectedSIZE,
  selectedSSL,
}) => {
  const getShiftValue = () => {
    if (shiftType === 'shift1') {
      return shiftData?.shift1;
    }
    if (shiftType === 'shift2') {
      return shiftData?.shift2;
    }
    return null;
  };

  const getShiftMessage = () => {
    if (shiftType === 'shift1') {
      return shiftData?.shift1_message;
    } else if (shiftType === 'shift2') {
      return shiftData?.shift2_message;
    }
    return null;
  };

  const getUniqueId = () => {
    return (
      terminalId + terminalSlug + restrictionName + containerType + shiftType
    );
  };

  const getHoveredIconKey = () => {
    const sizeLabel = selectedSIZE?.label || 'All';
    const sslLabel = selectedSSL?.label || 'All';
    const uniqueId = `${terminalId}-${terminalSlug}-${idx}-${restrictionKey}-${containerType}-${shiftType}-${sizeLabel}-${sslLabel}-${restrictionName}`;
    return uniqueId;
  };

  const getShiftIcon = (shiftValue, isHovered) => {
    if (shiftValue === false || shiftValue === 0) {
      return Icons.close;
    } else if (shiftValue === true || shiftValue === 1) {
      return Icons.tickICon;
    } else if (shiftValue === 'DUAL' || shiftValue === 2) {
      return Icons.transaction;
    }
    return null;
  };

  const getSimpleIcon = (shiftValue) => {
    if (shiftValue === false || shiftValue === 0) {
      return Icons.close;
    } else if (shiftValue === true || shiftValue === 1) {
      return Icons.tickICon;
    } else if (shiftValue === 'DUAL' || shiftValue === 2) {
      return Icons.transaction;
    }
    return null;
  };

  const getClassName = (shiftValue) => {
    if (shiftValue === true || shiftValue === 1) {
      return cls.open;
    } else if (shiftValue === false || shiftValue === 0) {
      return cls.close;
    } else if (shiftValue === 'DUAL' || shiftValue === 2) {
      return cls.dual;
    }
    return cls.nullStatuss;
  };

  const shiftValue = getShiftValue();
  const shiftMessage = getShiftMessage();
  const uniqueId = getUniqueId();
  const hoveredIconKey = getHoveredIconKey();

  const simpleIcon = getSimpleIcon(shiftValue);

  if (!simpleIcon) return null;

  if (shiftMessage) {
    const shiftIcon = getShiftIcon(shiftValue, false);

    if (!shiftIcon) return null;

    return (
      <>
        <ReactSVG src={shiftIcon} className={cls.iconUser} />

        <TooltipV2
          tooltipId={uniqueId}
          iconId={hoveredIconKey}
          arrow
          title={shiftMessage}
          style={{ marginTop: '-4px', marginRight: '-18px' }}
          placement="top">
          <ReactSVG src={Icons.tooltipInfo} className={cls.iconUserMsg} />
        </TooltipV2>
      </>
    );
  }

  return <ReactSVG src={simpleIcon} className={cls.iconUser} />;
};

export default ShiftStatus;
